var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 78 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1625 35.2917H12.8375C11.1323 35.2917 9.75 36.6563 9.75 38.3396V38.6604C9.75 40.3437 11.1323 41.7083 12.8375 41.7083H65.1625C66.8677 41.7083 68.25 40.3437 68.25 38.6604V38.3396C68.25 36.6563 66.8677 35.2917 65.1625 35.2917Z",
    fill: "#F2A20F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1625 51.3333H12.8375C11.1323 51.3333 9.75 52.6979 9.75 54.3812V54.7021C9.75 56.3854 11.1323 57.75 12.8375 57.75H65.1625C66.8677 57.75 68.25 56.3854 68.25 54.7021V54.3812C68.25 52.6979 66.8677 51.3333 65.1625 51.3333Z",
    fill: "#F2A20F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1625 19.25H12.8375C11.1323 19.25 9.75 20.6146 9.75 22.2979V22.6188C9.75 24.3021 11.1323 25.6667 12.8375 25.6667H65.1625C66.8677 25.6667 68.25 24.3021 68.25 22.6188V22.2979C68.25 20.6146 66.8677 19.25 65.1625 19.25Z",
    fill: "#F2A20F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.4789f23cfff7b52dba719b8d7bb0eded.svg";
export { ForwardRef as ReactComponent };